import React from 'react';

import './IconWrapper.scss';

export const IconWrapper = props => <i className="anticon icon_wrapper">{props.children}</i>;
